import { IconDownload, IconLoader2 } from '@tabler/icons-react'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useEmployeeSEsUnderASMFromStateMappingAPI, useEmployeeSEsUnderASMsAPI } from 'src/API/rest.employee'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { useInstitutionalForcast } from 'src/API/rest.InstitutionalForcast'
import { useReportAPIs } from 'src/API/rest.reports'
import { ButtonIconSquare } from 'src/components/buttons'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { InputStandard } from 'src/components/standard.input'
import { MultiselectStandard } from 'src/components/standard.multiselect'
import { TypographyH2 } from 'src/components/typography'
import { RootState } from 'src/redux/store'
import { toast } from 'src/shadcn/ui/use-toast'



export function SEForecastReport() {
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState(
        currentDate.toISOString().substring(0, 7) // Format: YYYY-MM
    );


    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })
    const userData = useSelector((state: RootState) => state.user.employeeDetails)




    const isAnyError = isErrorlatestCalendarDate
    const isAnyFething = isFetchinglatestCalendarDate
    const isLoading = isLoadinglatestCalendarDate

    const [employeeSelected, setemployeeSelected] = useState<number[]>([])



    const {
        sesfromStateMapping: emloyees,
        isSesFromStateMappingLoading: isLoadingEmployee,
        isSesFromStateMappingFetching: isFetchingEmployee,
        isSesFromStateMappingError: isEmployeeError,
    } = useEmployeeSEsUnderASMFromStateMappingAPI({
    })

    const {
        downloadSEwiseReport,
        isDownloadingProductDatas
    } = useReportAPIs()



    useEffect(
        () => {
            if (latestCalendarDate?.date) {
                setSelectedDate(format(latestCalendarDate?.date, 'yyyy-MM'))
            }
        }, [isLoadinglatestCalendarDate]
    )

    useEffect(
        () => {

            if(isEmployeeError){
                toast({
                    title: 'Error',
                    description: 'Error while fetching SEs',
                })
            }

        },[isFetchingEmployee])



    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col overflow-auto items-center '>


            {/* NP style wise */}
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-2 '>
                    <TypographyH2>SE Forecast Report</TypographyH2>
                    <div className=' flex gap-2 '>
                        {/* <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='date'
                            disabled
                            value={latestCalendarDate?.date || ''}
                        /> */}
                        <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='month'
                            onChange={(e) => {
                                setSelectedDate(e.target.value)
                            }}
                            disabled={isFetchinglatestCalendarDate}
                            value={selectedDate || ''}
                        />
                        <MultiselectStandard
                            title='SE'
                            // singleSelect
                            placeholder='Select SEs'
                            options={emloyees?.length ? [
                                ...emloyees?.map(emp => ({ value: String(emp.FM03_EmployeeID), label: `${emp.FM03_EmployeeName} - (${emp.FM03_EmployeeCode})` }))] : []}
                            onValueChange={(value) => setemployeeSelected(value.target.value?.map((id: string) => Number(id)))}
                            value={employeeSelected.map((id) => String(id))}
                            name='employee'
                        />
                    </div>

                    <div className=' grow flex flex-col justify-center items-center  w-min mx-auto mt-8'>

                        <ButtonIconSquare
                            className=' mx-auto mb-5'
                            icon={isDownloadingProductDatas ? <IconLoader2 className='animate-spin' /> : <IconDownload />}
                            onClick={async () => {

                                if(employeeSelected.length===0){
                                    toast({
                                        title: 'Error',
                                        description: 'Please select employee'
                                    })
                                    return
                                }

                                const response = await downloadSEwiseReport({
                                    date: latestCalendarDate?.date!,
                                    seIds: employeeSelected
                                })
                                if (response.success === false) {
                                    toast({
                                        title: 'Error',
                                        description: response.message
                                    })
                                }
                            }}
                            variant='secondary'
                            text='Download'
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

